module.exports = __webpack_public_path__ + "img/pdf.6a24acc3.svg";